<template>
  <section class="relative text-white h-[420px] md:h-[400px] overflow-hidden">
    <!-- Fondo azul -->
    <div class="absolute inset-0 bg-[#101541] z-0"></div>

    <!-- Imagen de fondo derecha -->
    <img
      src="@/assets/landingPorque.png"
      alt="Razones"
      class="absolute right-0 top-0 h-full w-auto max-w-none object-cover z-0"
    />

    <!-- Contenido -->
    <div
      class="relative z-10 px-6 sm:px-10 md:px-20 h-full flex flex-col justify-center w-full md:max-w-[60%]"
    >
      <h2 class="text-xl sm:text-2xl md:text-4xl font-bold mb-4 leading-snug">
        ¿Por qué somos tu mejor opción?
      </h2>
      <ul class="space-y-2 text-sm sm:text-base md:text-lg">
        <li>✔ Atención personalizada y seguimiento continuo</li>
        <li>✔ Asesoría experta en seguros y fianzas</li>
        <li>✔ Planes flexibles adaptados a tus necesidades</li>
        <li>✔ Cobertura nacional con respaldo internacional</li>
      </ul>
    </div>
  </section>
</template>
